module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_0@2x.de44fbb3.png";